import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import store from "./store";
import ErrorBoundary from "./App/ErrorBoundary";
import { HelmetProvider } from "react-helmet-async";
import { LocalizeProvider } from "react-localize-redux";
import { RequestProvider } from "./utils/context/RequestContext";


ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <LocalizeProvider>
          <HelmetProvider>
            <BrowserRouter>
              <RequestProvider>
                <App/>
              </RequestProvider>
            </BrowserRouter>
          </HelmetProvider>
        </LocalizeProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root"),
);
